"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = useRenderCellViews;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_2 = require("@heroui/react");
var utils_1 = require("@doshexchnage/utils");
var constants_1 = require("../constants");
function useRenderCellViews() {
    var renderCellViews = (0, react_1.useMemo)(function () {
        return function (cellValue, statistic) {
            var _a;
            return [
                {
                    key: "_id",
                    content: (0, jsx_runtime_1.jsxs)("div", { className: "text-sm text-muted font-mono", children: [(_a = cellValue === null || cellValue === void 0 ? void 0 : cellValue.toString()) === null || _a === void 0 ? void 0 : _a.substring(0, 8), "..."] }),
                },
                {
                    key: "name",
                    content: ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-default-foreground", children: cellValue || "N/A" }), (statistic === null || statistic === void 0 ? void 0 : statistic.built_in) && ((0, jsx_runtime_1.jsx)(react_2.Chip, { className: "text-nowrap", size: "sm", variant: "soft", color: "accent", children: "Built-in" }))] })),
                },
                {
                    key: "aggregation_method",
                    content: ((0, jsx_runtime_1.jsx)(react_2.Chip, { className: "text-nowrap", size: "sm", variant: "soft", children: cellValue || "N/A" })),
                },
                {
                    key: "reset_interval",
                    content: ((0, jsx_runtime_1.jsx)(react_2.Chip, { className: "text-nowrap", size: "sm", variant: "soft", children: cellValue ? (0, constants_1.resetIntervalLabel)(String(cellValue)) : "N/A" })),
                },
                {
                    key: "version",
                    content: ((0, jsx_runtime_1.jsxs)(react_2.Chip, { size: "sm", color: "accent", variant: "soft", children: ["v", cellValue || 0] })),
                },
                {
                    key: "next_reset_at",
                    content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-default-foreground", children: (0, constants_1.describeNextReset)(statistic === null || statistic === void 0 ? void 0 : statistic.reset_interval, statistic === null || statistic === void 0 ? void 0 : statistic.next_reset_at) }),
                },
                {
                    key: "created_at",
                    content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-default-foreground", children: cellValue ? (0, utils_1.formatDateTime)(new Date(cellValue)) : "N/A" }),
                },
            ];
        };
    }, []);
    return { renderCellViews: renderCellViews };
}
